<span class="recurrence-badge" [class.recurrence-badge--active]="recurring()">
  <sim-icon icon="repeat" [sizeInPx]="16" [color]="iconColor()" class="recurrence-badge__icon" />
  <span class="recurrence-badge__label" simEllipsisTooltip>{{ label() }}</span>
</span>
